<template>
  <a-spin
    tip="Your document is being processed, do not leave this page!"
    :spinning="loading.page"
  >
    <a-card>
      <span slot="title" class="m-text-title">Rekapitulasi Realisasi SPL</span>
      <a-tabs
        class="custom-tabs"
        :activeKey="tabs.active"
        @change="handleTab"
      >
        <a-tab-pane key="daftar">
          <template slot="tab">
            <span>Daftar Realisasi SPL</span>
            <a-badge
              class="m-badge m-badge-small"
              :count="dataSource.needProcess.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="dataSource.needProcess.length > 0"
            >
            </a-badge>
          </template>
          <a-input-search placeholder="Pencarian" v-model="search" @change="onChangeSearch" 
            class="textsearch" :loading="loadingSearch"></a-input-search>
          <a-table
            :rowKey="(record, index) => { return index.toString(); }"
            size="small"
            bordered
            :scroll="{ x: 850 }"
            :columns="columns.needProcess"
            :dataSource="needProcessSearchResult"
            :loading="tabs.loading"
            :pagination="pagination.needProcess"
            :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
          >
          <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
          <template slot="no_realisasi_spl" slot-scope="item">{{ item.no_realisasi_spl }}</template>
          <template slot="nama_dept" slot-scope="item">{{ item.nama_dept }}</template>
          <template slot="pelaksana" slot-scope="item">{{ item.pelaksana }}</template>
          <template slot="lokasi" slot-scope="item">{{ item.lokasi }}</template>
          <template slot="uraian" slot-scope="item">{{ item.uraian }}</template>
          <template slot="aksi1">
            <a-button icon="eye" size="small" type="primary"></a-button>
          </template>
          <span slot="customTitle">
            Aksi
            <a-checkbox
              style="padding-left:10px"
              v-model="check.all"
              :indeterminate="check.indeterminate"
              @change="onChangeCheckboxAll"
            />
          </span>
          <template slot="aksi2" slot-scope="item" >
            <a-checkbox
              :id="item.realisasi_spl_id"
              v-model="item.check"
              @change="onChangeCheckbox"
            />
          </template>
          <div slot="footer" class="m-text-right">
            <a-button type="primary" @click="visibleModalRekap" >Rekap</a-button>
          </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="rekap_realisasi">
          <template slot="tab">
            <span>Rekap Realisasi SPL</span>
            <!-- <a-badge
              class="m-badge m-badge-small"
              :count="dataSource.list.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="dataSource.list.length > 0"
            >
            </a-badge> -->
          </template>
          <a-input-search placeholder="Pencarian" v-model="search" @change="onChangeSearch" 
            class="textsearch" :loading="loadingSearch"></a-input-search>
          <a-table
            :rowKey="(record, index) => { return index.toString(); }"
            size="small"
            bordered
            :scroll="{ x: 850 }"
            :columns="columns.list"
            :dataSource="listSearchResult"
            :loading="tabs.loading"
            :pagination="pagination.list"
          >
          <template slot="nomor" slot-scope="text,item,index">{{ index + 1 }}</template>
          <template slot="norekap" slot-scope="item">{{ item.no_rekap }}</template>
          <template slot="tanggal" slot-scope="item">{{ moment(item.create_dt).format(getDefaultDateFormat) }}</template>
          <template slot="tlc" slot-scope="item">{{ item.tlc_create }}</template>
          <template slot="catatan" slot-scope="item">{{ item.catatan }}</template>
          <template slot="aksi" slot-scope="item">
            <a-button-group>
              <a-button type="primary" icon="eye" @click="showManifestRekap(item.id_rekap)"></a-button>
            </a-button-group>
          </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <a-modal
      v-model="modalRekap.visible"
      v-if="modalRekap.visible"
      title="Simpan Data Rekap Realisasi SPL"
      :maskClosable="false"
      @cancel="closemodal"
      >
      <div class="box-bg">
        <h4 style="margin-bottom:0px">Total data terseleksi : {{ modalRekap.totalData }} baris</h4>
      </div>
      <a-form-model ref="form" :model="modalRekap" :rules="rules">
        <a-form-model-item label="Catatan" prop="catatan">
          <a-textarea
            placeholder="Ketik catatan disini ... "
            :rows="4"
            v-model="modalRekap.catatan"
          />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" :loading="modalRekap.loadingSimpan" @click="handleRekap">Simpan</a-button>
      </template>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "list-rekapRealisasiSPL",
  mixins: [],
  components: {},
  data() {
    return {
      loading: {
        page: false
      },
      tabs: {
        active: 'daftar',
        loading: false,
      },
      dataSource: {
        needProcess: [],
        list: [],
      },
      columns: {
        needProcess: [{
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No. Realisasi SPL",
          key: "no_realisasi_spl",
          align: "center",
          scopedSlots: { customRender: "no_realisasi_spl" },
          width: 210,
        },
        {
          title: "Departemen",
          key: "nama_dept",
          align: "left",
          scopedSlots: { customRender: "nama_dept" },
          width: 200,
          },
        {
          title: "Pelaksana",
          key: "pelaksana",
          align: "center",
          scopedSlots: { customRender: "pelaksana" },
          width: 150,
          },
        {
          title: "Lokasi",
          key: "lokasi",
          align: "left",
          scopedSlots: { customRender: "lokasi" },
          width: 250,
          },
        {
          title: "Uraian Tugas",
          key: "uraian",
          align: "left",
          scopedSlots: { customRender: "uraian" },
          width: 300,
          },
        {
          slots: { title: 'customTitle' },
          key: "aksi1",
          align: "center",
          colSpan: 2,
          scopedSlots: { customRender: "aksi1" },
          width: 50,
          },
        {
          title: "Aksi",
          key: "aksi2",
          align: "center",
          colSpan: 0,
          scopedSlots: { customRender: "aksi2" },
          width: 50,
        },
        ],
        list: [{
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "Nomor Rekap",
          key: "norekap",
          align: "left",
          scopedSlots: { customRender: "norekap" },
          width: 250,
        },
        {
          title: "Tanggal",
          key: "tanggal",
          align: "center",
          scopedSlots: { customRender: "tanggal" },
          width: 100,
          },
        {
          title: "TLC Pembuat",
          key: "tlc",
          align: "center",
          scopedSlots: { customRender: "tlc" },
          width: 100,
          },
        {
          title: "Catatan",
          key: "catatan",
          align: "left",
          scopedSlots: { customRender: "catatan" },
          width: 300,
        },
        {
          title: "Aksi",
          key: "aksi",
          align: "center",
          scopedSlots: { customRender: "aksi" },
          width: 70,
        },
        ]
      },
      pagination: {
        needProcess: {
          onChange: (page) => {
            this.pagination.needProcess.page = page;
          },
          page: 1,
          pageSize: 10,
          size: "small",
        },
        list: {
          onChange: (page) => {
            this.pagination.list.page = page;
          },
          page: 1,
          pageSize: 10,
          size: "small",
        }
      },
      check : {
        all: false,
        indeterminate: false,
        isalready: false,
      },
      modalRekap: {
        visible: false,
        catatan: null,
        totalData: null,
        data: null,
        loadingSimpan: false,
      },
      rules: {
        catatan: {
          required: true,
          message: "Harap isi catatan!",
          trigger: "blur",
        },
      },
      search: undefined,
      loadingSearch: false,
      id: "",
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    needProcessSearchResult() {
      let result = null
        result = this.dataSource.needProcess
        if (this.search) {
          Event.$emit("loadSearch", true);
          result = _.filter(this.dataSource.needProcess, (e) =>
            e.no_realisasi_spl && e.no_realisasi_spl.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.nama_dept && e.nama_dept.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.pelaksana && e.pelaksana.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.lokasi && e.lokasi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.uraian && e.uraian.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )
          Event.$emit("loadSearch", false);
        }
      return result
    },
    listSearchResult() {
      let result = null
      result = this.dataSource.list
      if (this.search) {
        Event.$emit("loadSearch", true);
        result = _.filter(this.dataSource.list, (e) =>
          e.catatan && e.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          e.no_rekap && e.no_rekap.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          e.tlc_create && e.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          e.create_dt && moment(e.create_dt).format(this.getDefaultDateFormat).toLowerCase().indexOf(this.search.toLowerCase()) >= 0 
        )
        Event.$emit("loadSearch", false);
      }
      return result
    }
  },
  mounted() {
    Event.$on("loadSearch", this.loadingSearching);
    this.reload(this.tabs.active);
  },
  beforeDestroy() {
    Event.$off("loadSearch", this.loadingSearching);
  },
  methods: {
    moment,
    loadingSearching(val) {
      this.loadingSearch = val;
    },
    reload(tabs) {
      this.tabs.loading = true
      this.dataSource.needProcess = []
      this.dataSource.list = []
      this.asyncAxiosGet("Rekap_realisasi_lembur", this.getAuth, {
        rekap_realisasi: tabs,
      })
      .then((res) => {
        if (tabs=="rekap_realisasi") {
          this.dataSource.list = res.data
        } else {
          this.dataSource.needProcess = res.data
          for (let i = 0; i < this.dataSource.needProcess.length; i++) {
            this.dataSource.needProcess[i]['check'] = false;
          }
        }
        this.tabs.loading = false
      })
      .catch((err) => {
        console.log(err)
        this.tabs.loading = false
      });
    },
    handleTab(val) {
      this.tabs.active = val;
      this.check.all = false
      this.check.indeterminate = false
      this.check.isalready = false
      this.search = undefined
      this.reload(this.tabs.active);
    },
    onChangeCheckbox(val) {
      this.tabs.loading = true
      let idx = _.findIndex(this.dataSource.needProcess, (e) => e.realisasi_spl_id == val.target.id)
      this.dataSource.needProcess[idx].check = val.target.checked

      let alls = (_.filter(this.dataSource.needProcess, (e) => e.check == true)).length == this.dataSource.needProcess.length
      this.check.all = alls
      this.check.indeterminate = (alls ? false : this.isChecked());
      this.check.isalready = this.check.indeterminate

      this.tabs.loading = false
    },
    onChangeCheckboxAll(val) {
      for (let i = 0; i < this.dataSource.needProcess.length; i++) {
        this.dataSource.needProcess[i].check = val.target.checked
      }
      this.check.indeterminate = false;
      this.check.isalready = val.target.checked ? true : false
    },
    isChecked() {
      return (_.filter(this.dataSource.needProcess, (e) => e.check == true)).length > 0 ? true : false
    },
    showManifestRekap(id) {
      this.$router.push({
        name: "manifestRekapRealisasiSPL",
        params: { id: id },
      });
    },
    visibleModalRekap() {
      if (!this.check.isalready) {
        this.displayMessageValue('error-basic','Belum ada data terseleksi!')
      } else {
        this.modalRekap.visible = true
        this.modalRekap.data = _.filter(this.dataSource.needProcess, (e) => e.check == true)
        this.modalRekap.totalData = this.modalRekap.data.length
      }
    },
    closemodal() {
      this.modalRekap.visible = false
      this.modalRekap.totalData = null
      this.modalRekap.data = null
      this.modalRekap.catatan = null
    },
    handleRekap() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.modalRekap.loadingSimpan = true;
        let selected_item = []
        this.modalRekap.data.forEach((item) => {
          selected_item.push({ id: item.realisasi_spl_id })
        });
        this.asyncAxiosPost("rekap_realisasi_lembur", "application/json", this.getAuth,
          { selected_item: selected_item, catatan: this.modalRekap.catatan })
          .then(() => {
            this.displayMessage("success-save");
            this.modalRekap.loadingSimpan = false;
            this.tabs.active = "rekap_realisasi"

            this.modalRekap.visible = false
            this.modalRekap.totalData = null
            this.modalRekap.data = null
            this.modalRekap.catatan = null

            this.reload(this.tabs.active)
          })
          .catch((err) => {
            console.log(err);
            this.modalRekap.loadingSimpan = false;
          });
      })
    },
    onChangeSearch() {
      
    }
  }
}
</script>

<style>
.box-bg{
  background: #80808063;
  padding: 10px;
  border-radius: 3px;
}

.textsearch{
  margin-bottom : 16px!important;
}
</style>